/* eslint-disable import/prefer-default-export */
export const anamnese = {
  queixas: [
    { sintoma: 'Avaliação de rotina' },
    { sintoma: 'Retorno' },
    { sintoma: 'Aumento da PA' },
    { sintoma: 'Oscilação da PA' },
    { sintoma: 'Assintomático cardiovascular' },
    {
      sintoma:
        'Nega dor precordial, dispneia, palpitações, edemas, tonturas ou síncope',
    },
    { sintoma: 'Nega dor precordial relacionada com esforços' },
    { sintoma: 'Dor precordial relacionada com esforço físico' },
    { sintoma: 'Dor precordial em repouso, sem relação com esforço físico' },
    { sintoma: 'Dor torácica atípica' },
    { sintoma: 'Cansaço aos esforços' },
    { sintoma: 'Fone exames sangue' },
    { sintoma: 'WhatsApp exames sangue' },
    { sintoma: 'Cansaço físico, indisposição, sem dispnéia' },
    { sintoma: 'Palpitações frequentes' },
    { sintoma: 'Tonturas posturais' },
    { sintoma: 'Tonturas rotatórias (labirintopatia)' },
    { sintoma: 'Edema em MMII com piora vespertina' },
    { sintoma: 'Cefaléia frequente' },
    { sintoma: 'Cefaléia na região da nuca' },
    { sintoma: 'Avaliação pré-operatória de' },
    { sintoma: 'Avaliação para realização de' },
  ],
  habitos: [
    { sintoma: 'Sedent\u00e1rio' },
    { sintoma: 'Atividade f\u00edsica irregular' },
    { sintoma: 'Ativo no trabalho e em atividades di\u00e1rias' },
    { sintoma: 'Academia _x/semana' },
    { sintoma: 'Caminhada regular, _x/semana' },
    { sintoma: 'Hidrogin\u00e1stica _x/semana' },
    { sintoma: 'Pilates 2 vezes por semana' },
    { sintoma: 'Nega Tabagismo' },
    { sintoma: 'Nega tabagismo e etilismo' },
    { sintoma: 'Nega tabagismo, etilismo e consumo de caf\u00e9' },
    { sintoma: 'Tabagista, fuma cigarros por dia, desde' },
    { sintoma: 'Ex-tabagista, fumou por  anos, parou em' },
    { sintoma: 'Etilista, cerveja por dia' },
    { sintoma: 'Consumo social de bebida alco\u00f3lica' },
    { sintoma: 'Ex-etilista, parou em' },
    { sintoma: 'Nega consumo de caf\u00e9' },
    { sintoma: 'Consumo de caf\u00e9: bastante' },
    { sintoma: 'Dieta bem controlada' },
    { sintoma: 'Dieta n\u00e3o controlada' },
    { sintoma: 'Dieta pouco controlada, sem grandes abusos' },
    { sintoma: 'Acompanha com nutricionista, dieta bem controlada' },
  ],
  familiares: [
    { sintoma: 'Nega HAS, DM, Dislipidemia' },
    { sintoma: 'Nega DM e Dislipidemia' },
    { sintoma: 'Nega DAC e AVC' },
    { sintoma: 'Nega morte súbita' },
  ],
  pessoais: [
    { sintoma: 'Nega HAS, DM, Dislipidemia' },
    { sintoma: 'Nega DM e Dislipidemia' },
    { sintoma: 'Nega IAM ou AVC' },
    { sintoma: 'HAS desde' },
    { sintoma: 'DM desde' },
    { sintoma: 'Dislipidemia desde' },
    { sintoma: 'Epidemiologia Chagas negativo' },
    { sintoma: 'Epidemiologia Chagas positivo' },
    { sintoma: 'Ansioso' },
    { sintoma: 'Muito Ansioso' },
    { sintoma: 'Síndrome do Pânico' },
    { sintoma: 'Depressão desde' },
    { sintoma: 'Nega cirurgias prévias' },
    { sintoma: 'Nega alergia' },
    { sintoma: 'ATC+Stent convencional' },
    { sintoma: 'ATC+Stent farmacológico' },
    { sintoma: 'Revasc.Mioc.' },
    { sintoma: 'Hiperferritinemia' },
    { sintoma: 'Hipotireoidismo' },
    { sintoma: 'Hiperuricemia' },
    { sintoma: 'Hipertireoidismo' },
    { sintoma: 'Intolerância Glicose' },
  ],
  fisico: [
    {
      sintoma:
        'PA=  mmHg   e  FC=  bpm \nRCR, 2T sem sopros\nMV +, sem ruídos adventícios\nAbdome flácido e indolor. Ausência de VMG, com RHA presentes\nAusência de edema em MMII\nPulsos presentes e simétricos\nCarótidas sem sopro',
    },
    { sintoma: 'PA=  mmhg   e  FC=  bpm ' },
    { sintoma: 'RCR, 2T sem sopros' },
    { sintoma: 'RCR, 2T com sopro sistólico +/6+ em foco' },
    { sintoma: 'RCR, 2T com sopro diastólico +/4+ em foco' },
    { sintoma: 'RCI, em FA e sem sopros' },
    { sintoma: 'RCI, em FA e com sopro sistólico em foco' },
    { sintoma: 'MV +, sem ruídos adventícios' },
    { sintoma: 'MV+, com estertores creptantes em bases' },
    { sintoma: 'MV+, com estertores creptantes até terço médio' },
    { sintoma: 'MV+, com diminuição global' },
    { sintoma: 'Abdome flácido e indolor. Ausência de VMG, com RHA presentes' },
    {
      sintoma:
        'Abdome flácido e indolor. Fígado palpável 3cm do rebordo costal, indolor. RHA presentes',
    },
    { sintoma: 'Ausência de edema em MMII' },
    { sintoma: 'Presença de edema em MMII, +/4+' },
    { sintoma: 'Pulsos presentes e simétricos' },
    { sintoma: 'Pulsos diminuídos em MMII' },
    { sintoma: 'Ausência de estase jugular' },
    { sintoma: 'Presença de estase jugular +/+4' },
    { sintoma: 'Carótidas sem sopro' },
    { sintoma: 'Carótida com sopro sistólico +/4+ à' },
    { sintoma: 'FC:  bpm / PA:  x  mmHg / SatO²:  %.' },
    {
      sintoma:
        'Bom estado geral; acianótico(a); anictérico(a); corado(a) e hidratado(a).',
    },
    {
      sintoma:
        'ACV: Ritmo cardíaco regular em 2 tempos, bulhas normofonéticas, com/sem sopros audíveis.',
    },
    {
      sintoma:
        'AR: Murmúrio vesicular presente, sem ruídos adventícios, eupneico(a) em ar ambiente.',
    },
    {
      sintoma:
        'ABD: Globoso/Plano, flácido, sem massas palpáveis, ruídos hidroaéreos presentes. Indolor.',
    },
    {
      sintoma:
        'Extremidades: Pulsos arteriais simétricos nos 4 membros. Perfusão de 2-3 seg. Ausência de edema de membros inferiores.',
    },
  ],
  isda: [
    { sintoma: 'Nega alterações de hábitos urinário e intestinal' },
    { sintoma: 'Obstipação intestinal' },
    { sintoma: 'Nictúria' },
    { sintoma: 'Polaciúria' },
  ],
  hipoteses: [
    { sintoma: 'Avaliação de rotina' },
    { sintoma: 'Avaliação pré-operatória de' },
    { sintoma: 'Eutrófico Cardio' },
    { sintoma: 'Dor precordial' },
    { sintoma: 'Dor torácica' },
    { sintoma: 'Doença Arterial Coronariana Crônica Estável' },
    { sintoma: 'IAM em' },
    { sintoma: 'ATC+Stent convencional' },
    { sintoma: 'ATC+Stent farmacológico' },
    { sintoma: 'Revasc.Mioc.' },
    { sintoma: 'HAS' },
    { sintoma: 'PA oscilando (HAS?)' },
    { sintoma: 'Intolerância a Glicose' },
    { sintoma: 'Diabetes Mellitus tipo I' },
    { sintoma: 'Diabetes Mellitus tipo II' },
    { sintoma: 'Dislipidemia' },
    { sintoma: 'Síndrome Metabólica' },
    { sintoma: 'Obesidade' },
    { sintoma: 'IC FE Reduzida' },
    { sintoma: 'IC FE Preservada' },
    { sintoma: 'IC FE levemente reduzida' },
    { sintoma: 'IC FE Recuperada' },
    { sintoma: 'Fibrilação Atrial de início recente' },
    { sintoma: 'Fibrilação Atrial Permanente' },
    { sintoma: 'Fibrilação Atrial Persistente' },
    { sintoma: 'Fibrilação Atrial Paroxística' },
    { sintoma: 'Fibrilação Atrial revertida em' },
    { sintoma: 'Hiperferritinemia' },
    { sintoma: 'Hiperuricemia' },
    { sintoma: 'Hipertireoidismo' },
    { sintoma: 'Hipotireoidismo' },
    { sintoma: 'DPOC' },
    { sintoma: 'Ansiedade' },
    { sintoma: 'Depressão' },
    { sintoma: 'Síndrome do Pânico' },
  ],
  condutas: [
    { sintoma: 'Retornar para nova avaliação em' },
    {
      sintoma:
        'Mudanças de hábitos de vida (exercício, dieta e redução de peso)',
    },
    { sintoma: 'Melhorar dieta, aumentar exercício e reduzir peso' },
    { sintoma: 'Manter controle com dieta e exercício' },
    { sintoma: 'Controle da PA' },
    { sintoma: 'Exames laboratoriais' },
    { sintoma: 'Ecodopplercardio' },
    { sintoma: 'Eco Estresse Fisiológico' },
    { sintoma: 'Eco Estresse Farmacológico' },
    { sintoma: 'Eco Transesofágico' },
    { sintoma: 'Doppler de Carótidas' },
    { sintoma: 'Cintilografia do Miocárdio' },
    { sintoma: 'Teste Ergométrico' },
    { sintoma: 'Holter' },
    { sintoma: 'MAPA' },
    { sintoma: 'Looper' },
    { sintoma: 'Angiotomo de coronárias' },
    { sintoma: 'TC para escore de cálcio' },
    { sintoma: 'CATE' },
    { sintoma: 'Estudo Eletrofisiológico e Ablação' },
    { sintoma: 'Ultrasson de Abdome' },
    { sintoma: 'Cirurgia Cardíaca de Revascularização' },
    { sintoma: 'Cirurgia Cardíaca valvar' },
    { sintoma: 'Angioplastia com Stent em' },
  ],
  complementares: {
    id: 'root',
    name: 'Exames',
    children: [
      {
        id: '100',
        name: 'ICM',
        children: [
          { id: '101', name: 'AVALIAÇÃO E CONTROLE DE MARCA PASSO' },
          { id: '102', name: 'CETE' },
          { id: '103', name: 'CONSULTA EM CONSULTÓRIO' },
          { id: '104', name: 'ECG - ELETROCARDIOGRAMA' },
          { id: '105', name: 'ECOCARDIOGRAMA TRANSTORACICO' },
          { id: '106', name: 'ECODOPPLER DE CAROTIDAS COLLOR' },
          { id: '107', name: 'ECODOPPLER ESTRESSE' },
          { id: '108', name: 'ECODOPPLER TRANSESOFAGICO' },
          { id: '109', name: 'LOOPER' },
          { id: '110', name: 'MAPA 24 HRS' },
          { id: '111', name: 'SIST HOLTER 24 HS  DIGITAL [20102020]' },
          { id: '112', name: 'TESTE ERGO. COMPUTADORIZADO [40101037]' },
          { id: '113', name: 'TILT TESTE' },
          { id: '114', name: 'MRPA - MEDIÇÃO RESIDENCIAL DA PA' },
        ],
      },
      {
        id: '200',
        name: 'OUTROS EXAMES',
        children: [
          { id: '201', name: 'RX TÓRAX PA + P' },
          { id: '202', name: 'ULTRASSOM DE ABDOMEN SUPERIOR' },
          { id: '203', name: 'ULTRASSOM DE ABDOMEN TOTAL' },
        ],
      },
      {
        id: '300',
        name: 'LABORATORIAIS',
        children: [
          { id: '301', name: 'BILIRRUBINAS TOTAIS' },
          { id: '302', name: 'COLESTEROL TOTAL E FRAÇÕES' },
          { id: '303', name: 'CPK' },
          { id: '304', name: 'CREATININA' },
          { id: '305', name: 'FERRATINHA' },
          { id: '306', name: 'FOSFATASE ALCALINA' },
          { id: '307', name: 'GAMA GT' },
          { id: '308', name: 'GLICEMIA DE JEJUM' },
          { id: '309', name: 'HDL' },
          { id: '310', name: 'HEMOGRAMA COMPLETO' },
          { id: '311', name: 'POTASSIO' },
          { id: '312', name: 'PSA TOTAL E FRAÇÕES' },
          { id: '313', name: 'SODIO' },
          { id: '314', name: 'T4 LIVRE' },
          { id: '315', name: 'TGO' },
          { id: '316', name: 'TGP' },
          { id: '317', name: 'TSH' },
          { id: '318', name: 'TRIGLICERIDES' },
          { id: '319', name: 'URÉIA' },
          { id: '320', name: 'URINA TIPO 1' },
          { id: '321', name: 'VITAMINA D' },
          { id: '322', name: 'APO B' },
          { id: '323', name: 'LP(a)' },
        ],
      },
      {
        id: '400',
        name: 'BIOQUÍMICA (SANGUE)',
        children: [
          { id: '401', name: 'ÁCIDO FÓLICO' },
          { id: '402', name: 'ÁCIDO LÁCTICO ARTERIAL' },
          { id: '403', name: 'ÁCIDO LÁCTICO VENOSO' },
          { id: '404', name: 'ÁCIDO ÚRICO' },
          { id: '405', name: 'ALDOLASE' },
          { id: '406', name: 'ALFA 1 GLICOPROTEÍNA ÁCIDA' },
          { id: '407', name: 'AMILASE' },
          { id: '408', name: 'AMÔNEA' },
          { id: '409', name: 'BILIRRUBINAS' },
          { id: '410', name: 'CÁLCIO' },
          { id: '411', name: 'COBRE' },
          { id: '412', name: 'COLESTEROL TOTAL' },
          { id: '413', name: 'COLESTEROL HDL' },
          { id: '414', name: 'COLESTEROL LDL' },
          { id: '415', name: 'COLESTEROL VLDL' },
          { id: '416', name: 'CPK' },
          { id: '417', name: 'CPK - FRAÇÃO MB' },
          { id: '418', name: 'CREATININA' },
          { id: '419', name: 'DHL' },
          { id: '420', name: 'ELETROFORESE PROTEÍNAS' },
          { id: '421', name: 'FERRITINA' },
          { id: '422', name: 'FERRO' },
          { id: '423', name: 'FOSFATASE ÁCIDA' },
          { id: '424', name: 'FOSFATASE ALCALINA' },
          { id: '425', name: 'FÓSFORO' },
          { id: '426', name: 'FRUTATOSAMINA' },
          { id: '427', name: 'GAMA GT' },
          { id: '428', name: 'GASOMETRIA ARTERIAL' },
          { id: '429', name: 'GASOMETRIA VENOSA' },
          { id: '430', name: 'GLICOSE' },
          { id: '431', name: 'GTT - TESTE TOLERÂNCIA A GLICOSE' },
          { id: '432', name: 'HEMOGLOBINA GLICADA' },
          { id: '433', name: 'MAGNÉSIO' },
          { id: '434', name: 'POTÁSSIO' },
          { id: '435', name: 'SÓDIO' },
          { id: '436', name: 'PROTEÍNAS TOTAIS + ALBUMINA' },
          { id: '437', name: 'TGO' },
          { id: '438', name: 'TGP' },
          { id: '439', name: 'TRIGLICÉRIDES' },
          { id: '440', name: 'URÉIA' },
          { id: '441', name: 'VITAMINA B12' },
        ],
      },
      {
        id: '500',
        name: 'BIOQUÍMICA (URINA)',
        children: [
          { id: '501', name: 'ÁCIDO ÚRICO - URINA 24H' },
          { id: '502', name: 'CÁLCIO - URINA 24H' },
          { id: '503', name: 'CITRATO - URINA 24H' },
          { id: '504', name: 'CREATININA - URINA 24H' },
          { id: '505', name: 'CREATININA - DEPURAÇÃO' },
          { id: '506', name: 'FÓSFORO - URINA 24H' },
          { id: '507', name: 'GLICOSÚRIA 24H - PERÍODO ÚNICO' },
          { id: '508', name: 'GLICOSÚRIA 24H - 4 PERÍODOS' },
          { id: '509', name: 'MICROALBUMINA - URINA 12H' },
          { id: '510', name: 'MICROALBUMINA - URINA 24H' },
          { id: '511', name: 'OXALATO - URINA 24H' },
          { id: '512', name: 'POTÁSSIO - URINA 24H' },
          { id: '513', name: 'SÓDIO - URINA 24H' },
          { id: '514', name: 'PROTEINÚRIA 24H' },
        ],
      },
      {
        id: '600',
        name: 'IMUNOLOGIA',
        children: [
          { id: '601', name: 'ANTICARDIOLIPINA (LGG + LGM + LGA)' },
          { id: '602', name: 'ANTICOAGULANTE LÚPICO' },
          { id: '603', name: 'ANTIMITOCONDRIA, AC' },
          { id: '604', name: 'ANTI MÚSCULO LISO, AC' },
          { id: '605', name: 'ANTI NÚCLEO, ACS' },
          { id: '606', name: 'FAN' },
          { id: '607', name: 'RNP' },
          { id: '608', name: 'SSA' },
          { id: '609', name: 'DNA' },
          { id: '610', name: 'SM' },
          { id: '611', name: 'SSB' },
          { id: '612', name: 'ENA' },
          { id: '613', name: 'ASLO' },
          { id: '614', name: 'C3' },
          { id: '615', name: 'C4' },
          { id: '616', name: 'CD4/CD8' },
          { id: '617', name: 'CHAGAS' },
          { id: '618', name: 'CITOMEGALOVÍRUS (LGG + LGM)' },
          { id: '619', name: 'CRIOAGLUTININAS' },
          { id: '620', name: 'CRIOGLOBULINAS' },
          { id: '621', name: 'FATOR REUMATÓIDE' },
          { id: '622', name: 'HEPATITE A - AC. LGG' },
          { id: '623', name: 'HEPATITE A - AC. LGM' },
          { id: '624', name: 'HEPATITE B' },
          { id: '625', name: 'HBSAG' },
          { id: '626', name: 'HBE' },
          { id: '627', name: 'ANTI HBC' },
          { id: '628', name: 'ANTI HBSAG' },
          { id: '629', name: 'ANTI HBE' },
          { id: '630', name: 'ANTI HBC - LGM' },
          { id: '631', name: 'HEPATITE C, AC' },
          { id: '632', name: 'HERPES SIMPLES (LGG + LGM)' },
          { id: '633', name: 'HIV (HIV1 + HIV2)' },
        ],
      },
      {
        id: '700',
        name: 'IMUNOGLOBULINAS',
        children: [
          { id: '701', name: 'IGG' },
          { id: '702', name: 'IGA' },
          { id: '703', name: 'IGM' },
          { id: '704', name: 'IGE' },
          { id: '705', name: 'MICOPLASMA' },
          { id: '706', name: 'MONONUCLEOSE PAUL BUNNEL' },
          { id: '707', name: 'MONONUCLEOSE EPSTEIN BAAR - IGM' },
        ],
      },
      {
        id: '800',
        name: 'PROTEÍNA C REATIVA (PCR)',
        children: [
          { id: '801', name: 'AVALIAR RISCO CARDIOVASCULAR' },
          { id: '802', name: 'AVALIAR PROCESSO INFLAMATÓRIO' },
        ],
      },
      {
        id: '900',
        name: 'HEMATOLOGIA',
        children: [
          { id: '901', name: 'HEMOGRAMA COMPLETO' },
          { id: '902', name: 'COAGULOGRAMA COMPLETO' },
          { id: '903', name: 'FIBRINOGÊNIO' },
          { id: '904', name: 'PLAQUETAS' },
          { id: '905', name: 'TS - TC' },
          { id: '906', name: 'TP - INT' },
          { id: '907', name: 'TTPA' },
          { id: '908', name: 'COOMBS DIRETO' },
          { id: '909', name: 'COOMBS INDIRETO' },
          { id: '910', name: 'ELETROFORESE DE HEMOGLOBINA' },
          { id: '911', name: 'ERITROGRAMA' },
          { id: '912', name: 'FALCIZAÇÃO' },
          { id: '913', name: 'G6PD' },
          { id: '914', name: 'GRUPO SNAGUÍNEO - RH' },
          { id: '915', name: 'RETICULÓCITOS' },
          { id: '916', name: 'VHS' },
        ],
      },

      {
        id: '1000',
        name: 'HORMÔNIOS',
        children: [
          { id: '1001', name: '17OH PROGESTERONA' },
          { id: '1002', name: 'ANDROSTENEDIONA' },
          { id: '1003', name: 'BETA - HCG' },
          { id: '1004', name: 'CORTISOL BASAL 8H' },
          { id: '1005', name: 'CORTISOL BASAL 16H' },
          { id: '1006', name: 'CORTISOL PÓS DEXAMETASONA' },
          { id: '1007', name: 'DHEA' },
          { id: '1008', name: 'DHEA - SULFATO' },
          { id: '1009', name: 'ESTRADIOL' },
          { id: '1010', name: 'FSH' },
          { id: '1011', name: 'HORMÔNIO DE CRESCIMENTO' },
          { id: '1012', name: 'INSULINA' },
          { id: '1013', name: 'LH' },
          { id: '1014', name: 'PARATORMONIO (PTH)' },
          { id: '1015', name: 'PROGESTERONA' },
          { id: '1016', name: 'PROLACTINA' },
          { id: '1017', name: 'TESTOSTERONA TOTAL' },
          { id: '1018', name: 'TESTOSTERONA LIVRE' },
          { id: '1019', name: 'TIREÓIDE' },
          { id: '1020', name: 'ANTITIREOGLOBULINA, AC' },
          { id: '1021', name: 'ANTITIREOPEROXIDASE, AC' },
          { id: '1022', name: 'T3' },
          { id: '1023', name: 'T4 TOTAL' },
          { id: '1024', name: 'T4 LIVRE' },
          { id: '1025', name: 'TSH' },
          { id: '1026', name: 'TIREOGLOBULINA' },
          { id: '1027', name: 'TRAB' },
          { id: '1028', name: 'VMA - URINA 24H' },
          { id: '1029', name: 'CATECOLAMINAS - URINA 24H' },
          { id: '1030', name: 'METANEFRINAS - URINA 24H' },
        ],
      },
      {
        id: '1100',
        name: 'FEZES',
        children: [
          { id: '1101', name: 'FEZES-CULTURA' },
          { id: '1102', name: 'FEZES-ANTIBIOGRAMA' },
          { id: '1103', name: 'FEZES-CRIPTOSPORIDIUM, PESQUISA' },
          { id: '1104', name: 'FEZES-EXAME DIRETO' },
          { id: '1105', name: 'FEZES-GORDURAS,PESQUISA' },
          { id: '1106', name: 'FEZES-ISOSPORA, PESQUISA' },
          { id: '1107', name: 'FEZES-PARASITOLÓGICO AMOSTRA ÚNICA' },
          { id: '1108', name: 'FEZES-PARASITOLÓGICO TRÊS AMOSTRAS' },
          { id: '1109', name: 'FEZES-PROVA FUNCIONAL DIGESTIVA' },
          { id: '1110', name: 'FEZES-ROTAVÍRUS, PESQUISA' },
          { id: '1111', name: 'FEZES-SANGUE OCULTO, PESQUISA' },
          { id: '1112', name: 'FEZES-SUBSTÂNCIA REDUTORAS, PESQUISA' },
        ],
      },
      {
        id: '1200',
        name: 'URINA',
        children: [
          { id: '1201', name: 'URINA 1 - 1º JATO' },
          { id: '1202', name: 'URINA 1 -  JATO MÉDIO' },
          { id: '1203', name: 'UROCULTURA' },
          { id: '1204', name: 'URINA-ANTIBIOGRAMA' },
          { id: '1205', name: 'URINA-TESTE GRAVIDEZ' },
        ],
      },
      {
        id: '1300',
        name: 'SECREÇÕES E LÍQUIDOS CAVITÁRIOS',
        children: [
          { id: '1301', name: 'SECREÇÕES E LÍQUIDOS CAVITÁRIOS-MATERIAL' },
          { id: '1302', name: 'SECREÇÕES E LÍQUIDOS CAVITÁRIOS-CULTURA' },
          { id: '1303', name: 'SECREÇÕES E LÍQUIDOS CAVITÁRIOS-ANTIBIOGRAMA' },
          { id: '1304', name: 'CULTURA PARA FUNGOS' },
          { id: '1305', name: 'CHLAMYDIA' },
          { id: '1306', name: 'MICOPLASMA/UREAPLASMA' },
          { id: '1307', name: 'GRAM' },
          { id: '1308', name: 'HELICOBACTER PYLORI, PESQUISA' },
          { id: '1309', name: 'MICOLÓGICO DIREITO' },
          { id: '1310', name: 'ZIEHL' },
        ],
      },
      {
        id: '1400',
        name: 'MARCADORES',
        children: [
          { id: '1401', name: 'ALFAFETOPROTEÍNA' },
          { id: '1402', name: 'CEA' },
          { id: '1403', name: 'CA 19-9' },
          { id: '1404', name: 'CA 125' },
          { id: '1405', name: 'CA 15-3' },
          { id: '1406', name: 'PSA TOTAL' },
        ],
      },
      {
        id: '1500',
        name: 'OUTROS',
        children: [
          { id: '1501', name: 'CITOGRAMA NASAL' },
          { id: '1502', name: 'ESPERMOGRAMA' },
          { id: '1503', name: 'PPD' },
        ],
      },
    ],
  },
};